<template>
  <div>
      <div class="row mb-4"> 
        <div class="col">
            <div class="card">
                <div class="card-header">
                    <h4>Datos a Clonar</h4>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <table class="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <input @change="ChangeHeaderInput" type="checkbox" id="clone-option-header"  v-model="cloneOptions.header"/>
                                        <label class="ml-4" for="clone-option-header">Datos Principales</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input type="checkbox" id="clone-option-dispatch" v-model="cloneOptions.dispatch"/>
                                        <label class="ml-4" for="clone-option-dispatch">Datos de Despacho</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input type="checkbox" id="clone-option-new-composition" v-model="cloneOptions.newProduct"/>
                                        <label class="ml-4" for="clone-option-new-composition">Muestra Nuevo Producto</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input type="checkbox" id="clone-option-pt" v-model="cloneOptions.pt"/>
                                        <label class="ml-4" for="clone-option-pt">Muestras Producto Terminado</label>
                                    </td>
                                </tr>
                                <!-- Guarda Botella / Semielaborado deshabilitado. Se conserva por si se reactiva. -->
                                <tr v-if="false">
                                    <td>
                                        <input type="checkbox" id="clone-option-gb" v-model="cloneOptions.gb"/>
                                        <label class="ml-4" for="clone-option-gb">Muestras Guarda Botella (Semielaborados)</label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="row" id="header-data-form">
        <div class="col">
            <div class="card">
                <div class="card-header">
                    <h4>Datos Principales</h4>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label for="business-unit">Unidad de negocio</label>
                        <v-select id="business-unit" v-model="newHeader.businessUnit" @input="getCostCenters" :options="businessUnits">
                            <span slot="no-options">No se encontraron unidades de negocio</span>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <label for="cost-center">Centro de Costo</label>
                        <v-select :options="costCenters" :filterable="false" v-model="newHeader.costCenter" @search="onSearch">
                            <template slot="no-options">
                                No se encontraron registros
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                    {{ option.label }}
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                    {{ option.label }}
                                </div>
                            </template>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <label for="required-dispatch-date">Fecha requerida Despacho</label>
                        <input type="date" :min="minDate" class="form-control" id="required-dispatch-date" v-model="newHeader.requiredDispatchDate" >
                    </div>
                    <div class="form-group">
                        <label for="required-dispatch-date">Despacho Progresivo</label>
                        <b-form-checkbox @change="progressDispatchChange()" v-model="newHeader.progressDispatch"
                                name="check-button"
                                switch
                                class="mt-2"
                            >{{label}}
                        </b-form-checkbox>
                    </div>
                    <div class="form-group">
                        <label for="Comments">Objetivo de la Muestra</label>
                        <v-select v-model="newHeader.sampleTarget" :options="sampleTargets" id="Sampletarget" >
                            <span slot="no-options">No se encontraron Objetivos de muestra</span>
                        </v-select>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <button @click="saveCloneRequest" class="btn btn-block btn-success">
              <i class="fa fa-save"></i>
              Guardar
            </button>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
    import {Get} from '../../../helper/axios.js'
    import _ from "lodash";
    import $ from "jquery";
    export default {
        props: ["cloneOptions", "id","newHeader"],
        data() {
            return {
                apiUrl: this.$store.getters.apiUrl,
                businessUnits: [],
                costCenters: [],
                sampleTargets: [],
                minDate: '',
                label: "No",
                Get
            };
        },
        created() {
            this.getBusinessUnits();
            this.getSampleTarget();
            var today = new Date();
            var dd = String(today.getDate() + 2).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0');
            var yyyy = today.getFullYear();
            this.minDate = yyyy + '-' + mm + '-' + dd;
        },
        methods: {
            saveCloneRequest() {
                if (!this.cloneOptions.header)
                {
                    if (!this.newHeader.businessUnit || !this.newHeader.costCenter || !this.newHeader.sampleTarget || !this.newHeader.requiredDispatchDate)
                        window.toastr.warning('Debe ingresar los datos principales: Unidad de Negocio, Centro de Costo, Objetivo de Muestra, Fecha Requerida de Despacho');
                    else
                        this.$emit("saveCloneRequest");
                }
                else
                    this.$emit("saveCloneRequest");
            },
            getBusinessUnits() {
                this.$store.commit("setLoading", true);
                this.Get(this.apiUrl+'v1/businessunits', (res) => {
                    res.data.data.forEach(element => {
                        this.businessUnits.push({
                            label: element.name,
                            code: element.id
                        });
                    });
                    this.$store.commit("setLoading", false);
                })
            },
            getSampleTarget() {
                this.$store.commit("setLoading", true);
                this.Get(this.apiUrl+'v1/sampletarget', (res) => {
                    res.data.data.forEach(element => {
                        this.sampleTargets.push({
                            label: element.name,
                            code: element.id
                        });
                    });
                    this.$store.commit("setLoading", false);
                })
            },
            getCostCenters() {
                if (this.newHeader.businessUnit.code) {
                    this.$store.commit("setLoading", true);
                    this.Get(`${this.apiUrl}v1/businessunit/${this.newHeader.businessUnit.code}/costcenters`, (res) => {
                        this.costCenters = [];
                        res.data.forEach(item => { 
                            this.costCenters.push({
                                code: item.id,
                                label: item.name
                            });
                        });
                        this.$store.commit("setLoading", false);
                    });
                }
            },
            ChangeHeaderInput(){
                let checked = $("#clone-option-header").is(':checked');
                if (checked)
                {
                    $("#header-data-form").hide();
                    this.newHeader.businessUnit = null,
                    this.newHeader.costCenter = null,
                    this.newHeader.requiredDispatchDate = null,
                    this.newHeader.progressDispatch = false,
                    this.newHeader.sampleTarget = null
                }
                else
                    $("#header-data-form").show();
            },
            progressDispatchChange(){
                if (this.label == "No"){
                    this.label = "Si";
                }
                else if (this.label == "Si")
                    this.label = "No";
            },
            onSearch(search, loading) {
                if(search.length)
                {
                    loading(true);
                    this.search(loading, search, this)
                }
            },
            search: _.debounce((loading, search, vm) => {
                let data = "Search=" + search + "&Size=10&BusinessUnitId=" + vm.newHeader.businessUnit.code;
                vm.Get(vm.apiUrl + "v1/costCentersBusinessUnits?" + data, (res) => {
                    vm.costCenters=[];
                    res.data.forEach(item => { 
                        vm.costCenters.push({
                            code: item.id,
                            label: item.name
                        });
                    });
                loading(false)
                });
            }, 500)
        }
    };
</script>
